import { handleSupabaseAuthRedirect } from "@/lib/authRedirect";
import { useAppStore } from "@/stores/useStore";
import * as Linking from "expo-linking";
import { router } from "expo-router";
import { useEffect } from "react";
import { ActivityIndicator, StyleSheet, View } from "react-native";
import { Text } from "react-native-paper";

export default function AuthCallbackScreen() {
  const loadCurrentUser = useAppStore((state) => state.loadCurrentUser);

  useEffect(() => {
    let cancelled = false;

    const restoreSession = async () => {
      try {
        const initialUrl = await Linking.getInitialURL();
        await handleSupabaseAuthRedirect(initialUrl, loadCurrentUser);
      } catch (error) {
        console.warn("Failed to complete auth callback", error);
      } finally {
        if (!cancelled) {
          router.replace("/(tabs)/profile");
        }
      }
    };

    restoreSession();

    return () => {
      cancelled = true;
    };
  }, [loadCurrentUser]);

  return (
    <View style={styles.container}>
      <ActivityIndicator />
      <Text style={styles.text}>ログインを完了しています...</Text>
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    alignItems: "center",
    flex: 1,
    gap: 12,
    justifyContent: "center",
    padding: 24,
  },
  text: {
    textAlign: "center",
  },
});
